<template>
  <div id="weeklySchedulePage"
       class="container-fluid has-action-bar has-footer">
    <ActionBar title="برنامه هفتگی"></ActionBar>
    <div class="row container mx-auto p-0 mt-2">
      <div class="col-12 col-sm-8 col-md-6 col-lg-6 p-0 mb-4 mx-auto">
        <div class="member-ship-tab p-2 d-flex justify-space-between">
          <v-btn :class="{active: lessonSchedule}" class="px-lg-16 px-9" color="third" rounded
                 @click="showLessonSchedule"><span class="font12px">برنامه درسی</span>
          </v-btn>
          <v-btn :class="{active: sportsSchedule}" class=" px-lg-16 px-9" color="third" rounded
                 @click="showSportsSchedule"><span class="font12px">زنگ های تفریح</span>
          </v-btn>
        </div>
      </div>
    </div>
    <div v-if="lessonSchedule">
      <div class="row container mx-auto p-0 mt-2">
        <div v-if="satLessons.length > 0" class="rounded col-lg-4 col-sm-9 mx-auto col-12 my-2">
          <div class="bg-white p-1 round5px">
            <div class="light-purple-bg white--text p-1">
              <span class="p-1 px-4 purple-gradient-btn round5px ml-2"></span> شنبه
            </div>
            <div v-for="item in satLessons" :key="item.StartTimeScheduleID"
                 class="col-12 saturday-bg light-gray-bottom-border px-md-2 p-1">
              <div class="row no-gutters ">
                <div class="col-1">
                  <img alt="زنگ" class="img-fluid mt-1" src="../assets/img/bell.png"/></div>
                <div class="col-3">{{ item.Name }}</div>
                <div class="col-4 font12px gray-color text-center">{{ item.EndTime.slice(0, 5) }}
                  -{{ item.StartTime.slice(0, 5) }}
                </div>
                <div class="col-4 text-center">{{ item.LessonsFunName }}</div>
              </div>
            </div>

          </div>
        </div>
        <div v-if="sunLessons.length > 0" class="rounded col-lg-4 col-sm-9 mx-auto col-12 my-2">
          <div class="bg-white p-1 round5px">
            <div class="sunday-header-bg white--text p-1">
              <span class="p-1 px-4 gradient-btn round5px ml-2"></span> یکشنبه
            </div>
            <div v-for="item in sunLessons" :key="item.StartTimeScheduleID"
                 class="col-12 sunday-bg light-gray-bottom-border px-md-2 p-1">
              <div class="row no-gutters ">
                <div class="col-1">
                  <img alt="زنگ" class="img-fluid mt-1" src="../assets/img/bell.png"/></div>
                <div class="col-3">{{ item.Name }}</div>
                <div class="col-4 font12px gray-color text-center">{{ item.EndTime.slice(0, 5) }}
                  -{{ item.StartTime.slice(0, 5) }}
                </div>
                <div class="col-4 text-center">{{ item.LessonsFunName }}</div>
              </div>
            </div>

          </div>
        </div>
        <div v-if="monLessons.length > 0" class="rounded col-lg-4 col-sm-9 mx-auto col-12 my-2">
          <div class="bg-white p-1 round5px">
            <div class="monday-header-bg white--text p-1">
              <span class="p-1 px-4 blue-gradient round5px ml-2"></span> دوشنبه
            </div>
            <div v-for="item in monLessons" :key="item.StartTimeScheduleID"
                 class="col-12 monday-bg light-gray-bottom-border px-md-2 p-1">
              <div class="row no-gutters ">
                <div class="col-1">
                  <img alt="زنگ" class="img-fluid mt-1" src="../assets/img/bell.png"/></div>
                <div class="col-3">{{ item.Name }}</div>
                <div class="col-4 font12px gray-color text-center">{{ item.EndTime.slice(0, 5) }}
                  -{{ item.StartTime.slice(0, 5) }}
                </div>
                <div class="col-4 text-center">{{ item.LessonsFunName }}</div>
              </div>
            </div>

          </div>
        </div>
        <div v-if="tuesLessons.length > 0" class="rounded col-lg-4 col-sm-9 mx-auto col-12 my-2">
          <div class="bg-white p-1 round5px">
            <div class="tuesday-header-bg white--text p-1">
              <span class="p-1 px-4 pink-gradient round5px ml-2"></span> سه شنبه
            </div>
            <div v-for="item in tuesLessons" :key="item.StartTimeScheduleID"
                 class="col-12 tuesday-bg light-gray-bottom-border px-md-2 p-1">
              <div class="row no-gutters ">
                <div class="col-1">
                  <img alt="زنگ" class="img-fluid mt-1" src="../assets/img/bell.png"/></div>
                <div class="col-3">{{ item.Name }}</div>
                <div class="col-4 font12px gray-color text-center">{{ item.EndTime.slice(0, 5) }}
                  -{{ item.StartTime.slice(0, 5) }}
                </div>
                <div class="col-4 text-center">{{ item.LessonsFunName }}</div>
              </div>
            </div>

          </div>
        </div>
        <div v-if="wednesdayLessons.length > 0" class="rounded col-lg-4 col-sm-9 mx-auto col-12 my-2">
          <div class="bg-white p-1 round5px">
            <div class="wednesday-header-bg white--text p-1">
              <span class="p-1 px-4 light-green-gradient round5px ml-2"></span> چهار شنبه
            </div>
            <div v-for="item in wednesdayLessons" :key="item.StartTimeScheduleID"
                 class="col-12 wednesday-bg light-gray-bottom-border px-md-2 p-1">
              <div class="row no-gutters ">
                <div class="col-1">
                  <img alt="زنگ" class="img-fluid mt-1" src="../assets/img/bell.png"/></div>
                <div class="col-3">{{ item.Name }}</div>
                <div class="col-4 font12px gray-color text-center">{{ item.EndTime.slice(0, 5) }}
                  -{{ item.StartTime.slice(0, 5) }}
                </div>
                <div class="col-4 text-center">{{ item.LessonsFunName }}</div>
              </div>
            </div>

          </div>
        </div>
        <div v-if="fridayLessons.length > 0" class="rounded col-lg-4 col-sm-9 mx-auto col-12 my-2">
          <div class="bg-white p-1 round5px">
            <div class="thursday-header-bg white--text p-1">
              <span class="p-1 px-4 yellow-gradient round5px ml-2"></span> پنج شنبه
            </div>
            <div v-for="item in fridayLessons" :key="item.StartTimeScheduleID"
                 class="col-12 thursday-bg light-gray-bottom-border px-md-2 p-1">
              <div class="row no-gutters ">
                <div class="col-1">
                  <img alt="زنگ" class="img-fluid mt-1" src="../assets/img/bell.png"/></div>
                <div class="col-3">{{ item.Name }}</div>
                <div class="col-4 font12px gray-color text-center">{{ item.EndTime.slice(0, 5) }}
                  -{{ item.StartTime.slice(0, 5) }}
                </div>
                <div class="col-4 text-center">{{ item.LessonsFunName }}</div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div v-if="sportsSchedule">
      <div class="row container mx-auto p-0 mt-2">
        <div v-if="satFun.length >0" class="rounded col-lg-4 col-sm-9 mx-auto col-12 my-2">
          <div class="bg-white p-1 round5px">
            <div class="light-purple-bg white--text p-1">
              <span class="p-1 px-4 purple-gradient-btn round5px ml-2"></span> شنبه
            </div>
            <div v-for="item in satFun" :key="item.TimeScheduleID"
                 class="col-12 saturday-bg light-gray-bottom-border px-md-2 p-1">
              <div class="row no-gutters ">
                <div class="col-1">
                  <img alt="زنگ" class="img-fluid mt-1" src="../assets/img/bell.png"/></div>
                <div class="col-4">{{ item.Name }}</div>
                <div class="col-3 font12px gray-color text-center">{{ item.EndTime.slice(0, 5) }}
                  -{{ item.StartTime.slice(0, 5) }}
                </div>
                <div class="col-4 text-center">{{ item.LessonsFunName }}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="sunFun.length >0" class="rounded col-lg-4 col-sm-9 mx-auto col-12 my-2">
          <div class="bg-white p-1 round5px">
            <div class="sunday-header-bg white--text p-1">
              <span class="p-1 px-4 gradient-btn round5px ml-2"></span> یکشنبه
            </div>
            <div v-for="item in sunFun" :key="item.TimeScheduleID"
                 class="col-12 sunday-bg light-gray-bottom-border px-md-2 p-1">
              <div class="row no-gutters ">
                <div class="col-1">
                  <img alt="زنگ" class="img-fluid mt-1" src="../assets/img/bell.png"/></div>
                <div class="col-4">{{ item.Name }}</div>
                <div class="col-3 font12px gray-color text-center">{{ item.EndTime.slice(0, 5) }}
                  -{{ item.StartTime.slice(0, 5) }}
                </div>
                <div class="col-4 text-center">{{ item.LessonsFunName }}</div>
              </div>
            </div>

          </div>
        </div>
        <div v-if="monFun.length >0" class="rounded col-lg-4 col-sm-9 mx-auto col-12 my-2">
          <div class="bg-white p-1 round5px">
            <div class="monday-header-bg white--text p-1">
              <span class="p-1 px-4 blue-gradient round5px ml-2"></span> دوشنبه
            </div>
            <div v-for="item in monFun" :key="item.TimeScheduleID"
                 class="col-12 monday-bg light-gray-bottom-border px-md-2 p-1">
              <div class="row no-gutters ">
                <div class="col-1">
                  <img alt="زنگ" class="img-fluid mt-1" src="../assets/img/bell.png"/></div>
                <div class="col-4">{{ item.Name }}</div>
                <div class="col-3 font12px gray-color text-center">{{ item.EndTime.slice(0, 5) }}
                  -{{ item.StartTime.slice(0, 5) }}
                </div>
                <div class="col-4 text-center">{{ item.LessonsFunName }}</div>
              </div>
            </div>

          </div>
        </div>
        <div v-if="tuesFun.length >0" class="rounded col-lg-4 col-sm-9 mx-auto col-12 my-2">
          <div class="bg-white p-1 round5px">
            <div class="tuesday-header-bg white--text p-1">
              <span class="p-1 px-4 pink-gradient round5px ml-2"></span> سه شنبه
            </div>
            <div v-for="item in tuesFun" :key="item.TimeScheduleID"
                 class="col-12 tuesday-bg light-gray-bottom-border px-md-2 p-1">
              <div class="row no-gutters ">
                <div class="col-1">
                  <img alt="زنگ" class="img-fluid mt-1" src="../assets/img/bell.png"/></div>
                <div class="col-4">{{ item.Name }}</div>
                <div class="col-3 font12px gray-color text-center">{{ item.EndTime.slice(0, 5) }}
                  -{{ item.StartTime.slice(0, 5) }}
                </div>
                <div class="col-4 text-center">{{ item.LessonsFunName }}</div>
              </div>
            </div>

          </div>
        </div>
        <div v-if="wednesdayFun.length >0" class="rounded col-lg-4 col-sm-9 mx-auto col-12 my-2">
          <div class="bg-white p-1 round5px">
            <div class="wednesday-header-bg white--text p-1">
              <span class="p-1 px-4 light-green-gradient round5px ml-2"></span> چهار شنبه
            </div>
            <div v-for="item in wednesdayFun" :key="item.TimeScheduleID"
                 class="col-12 wednesday-bg light-gray-bottom-border px-md-2 p-1">
              <div class="row no-gutters ">
                <div class="col-1">
                  <img alt="زنگ" class="img-fluid mt-1" src="../assets/img/bell.png"/></div>
                <div class="col-4">{{ item.Name }}</div>
                <div class="col-3 font12px gray-color text-center">{{ item.EndTime.slice(0, 5) }}
                  -{{ item.StartTime.slice(0, 5) }}
                </div>
                <div class="col-4 text-center">{{ item.LessonsFunName }}</div>
              </div>
            </div>

          </div>
        </div>
        <div v-if="fridayFun.length >0" class="rounded col-lg-4 col-sm-9 mx-auto col-12 my-2">
          <div class="bg-white p-1 round5px">
            <div class="thursday-header-bg white--text p-1">
              <span class="p-1 px-4 yellow-gradient round5px ml-2"></span> پنج شنبه
            </div>
            <div v-for="item in fridayFun" :key="item.TimeScheduleID"
                 class="col-12 thursday-bg light-gray-bottom-border px-md-2 p-1">
              <div class="row no-gutters ">
                <div class="col-1">
                  <img alt="زنگ" class="img-fluid mt-1" src="../assets/img/bell.png"/></div>
                <div class="col-4">{{ item.Name }}</div>
                <div class="col-3 font12px gray-color text-center">{{ item.EndTime.slice(0, 5) }}
                  -{{ item.StartTime.slice(0, 5) }}
                </div>
                <div class="col-4 text-center">{{ item.LessonsFunName }}</div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <FooterMenu/>
    <v-dialog
        v-model="showLoaderDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center py-5">
        <v-progress-circular
            color="primary"
            indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
let _this = null
import ActionBar from "../components/ActionBar";
import FooterMenu from "../components/FooterMenu";

export default {
  name: "WeeklySchedule",

  metaInfo: {
    title: 'مسیربرتر-برنامه هفتگی'
  },
  components: {FooterMenu, ActionBar},
  data: () => ({
    lessonSchedule: true,
    sportsSchedule: false,
    showLoaderDialog: false,
    satLessons: [],
    sunLessons: [],
    monLessons: [],
    tuesLessons: [],
    wednesdayLessons: [],
    fridayLessons: [],
    satFun: [],
    sunFun: [],
    monFun: [],
    tuesFun: [],
    wednesdayFun: [],
    fridayFun: [],
  }),
  mounted() {
    _this = this;
    this.showLoaderDialog = true
    this.getData()
  },
  methods: {
    getData() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "TimeScheduleManagement/List", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            let lessons = json.filter(x => x.TypeLessonsFun === 1 && x.IsActive === true)
            let fun = json.filter(x => x.TypeLessonsFun === 2 && x.IsActive === true)
            _this.satLessons = lessons.filter(x => x.TypeDay === 1).sort((a, b) => a.StartTime.localeCompare(b.StartTime));
            _this.sunLessons = lessons.filter(x => x.TypeDay === 2).sort((a, b) => a.StartTime.localeCompare(b.StartTime));
            _this.monLessons = lessons.filter(x => x.TypeDay === 3).sort((a, b) => a.StartTime.localeCompare(b.StartTime));
            _this.tuesLessons = lessons.filter(x => x.TypeDay === 4).sort((a, b) => a.StartTime.localeCompare(b.StartTime));
            _this.wednesdayLessons = lessons.filter(x => x.TypeDay === 5).sort((a, b) => a.StartTime.localeCompare(b.StartTime));
            _this.fridayLessons = lessons.filter(x => x.TypeDay === 6).sort((a, b) => a.StartTime.localeCompare(b.StartTime));
            _this.satFun = fun.filter(x => x.TypeDay === 1).sort((a, b) => a.StartTime.localeCompare(b.StartTime));
            _this.sunFun = fun.filter(x => x.TypeDay === 2).sort((a, b) => a.StartTime.localeCompare(b.StartTime));
            _this.monFun = fun.filter(x => x.TypeDay === 3).sort((a, b) => a.StartTime.localeCompare(b.StartTime));
            _this.tuesFun = fun.filter(x => x.TypeDay === 4).sort((a, b) => a.StartTime.localeCompare(b.StartTime));
            _this.wednesdayFun = fun.filter(x => x.TypeDay === 5).sort((a, b) => a.StartTime.localeCompare(b.StartTime));
            _this.fridayFun = fun.filter(x => x.TypeDay === 6).sort((a, b) => a.StartTime.localeCompare(b.StartTime));
            _this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    },
    showLessonSchedule() {
      this.lessonSchedule = true;
      this.sportsSchedule = false;
    },
    showSportsSchedule() {
      this.lessonSchedule = false;
      this.sportsSchedule = true;
    }
  }
}
</script>
